/**
 * Checks if the value is a valid email address.
 * @param {string} value
 * @returns {boolean}
 */
export function isValidEmail(value) {
  const normalizedValue = `${value || ''}`.trim().toLowerCase();
  if (!normalizedValue) {
    return false;
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(normalizedValue);
}
